module.exports = __webpack_public_path__ + "static/media/bullet-triangle.0c130cda.svg";